import { useEffect, useState } from 'react';

import { MILLISECONDS_PER_SECOND } from 'constants/date';

// DEV-3055: forces a re-render on a fixed interval while `active` is true, so a
// value derived from `Date.now()` (e.g. a RUNNING run/step duration computed by
// formatDuration) advances smoothly second-by-second instead of freezing until
// the next SignalR store update. The interval is cleared when `active` becomes
// false (e.g. the run completes), so a finished run does not keep re-rendering.
const useNowTick = (active, intervalMs = MILLISECONDS_PER_SECOND) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!active) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      setTick(tick => tick + 1);
    }, intervalMs);

    return () => clearInterval(intervalId);
  }, [active, intervalMs]);
};

export default useNowTick;
